var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('heroSection',{attrs:{"typePage":"subHero-btn"}}),_c('section',[_c('div',{},[_c('div',{staticClass:"row"},[_c('searchSection')],1)])]),_c('newsLetters'),_c('partenairesSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }